interface Properties {
  width?: number;
  height?: number;
  color?: string;
}

/** Exact "trash (2)" asset from the Figma 3-dot Edit/Delete menu. */
const FigmaTrashIcon = ({ width = 16, height = 16, color = '#121826' }: Properties) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 14.6667 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M14.6667 3C14.6667 2.44772 14.219 2 13.6667 2H11.1493C10.7281 0.804906 9.6005 0.0040625 8.33334 0H6.33334C5.06619 0.0040625 3.93859 0.804906 3.51734 2H1C0.447719 2 0 2.44772 0 3C0 3.55228 0.447719 4 1 4H1.33334V12.3333C1.33334 14.3584 2.97497 16 5 16H9.66666C11.6917 16 13.3333 14.3584 13.3333 12.3333V4H13.6667C14.219 4 14.6667 3.55228 14.6667 3ZM11.3333 12.3333C11.3333 13.2538 10.5872 14 9.66669 14H5C4.07953 14 3.33334 13.2538 3.33334 12.3333V4H11.3333V12.3333Z'
        fill={color}
      />
      <path
        d='M5.66669 12C6.21897 12 6.66669 11.5523 6.66669 11V7C6.66669 6.44772 6.21897 6 5.66669 6C5.11441 6 4.66669 6.44772 4.66669 7V11C4.66669 11.5523 5.11441 12 5.66669 12Z'
        fill={color}
      />
      <path
        d='M9 12C9.55228 12 10 11.5523 10 11V7C10 6.44772 9.55228 6 9 6C8.44772 6 8 6.44772 8 7V11C8 11.5523 8.44772 12 9 12Z'
        fill={color}
      />
    </svg>
  );
};

export default FigmaTrashIcon;
